export enum ColourNames {
  black = 'Black',
  blue = 'Blue',
  cyan = 'Cyan',
  gray = 'Gray',
  green = 'Green',
  indigo = 'Indigo',
  orange = 'Orange',
  pink = 'Pink',
  purple = 'Purple',
  red = 'Red',
  teal = 'Teal',
  white = 'White',
  yellow = 'Yellow',
}
